
import Vue from "vue";
import SeaBackground from "../components/SeaBackground.vue";
import BGItem from "../components/BGItem.vue";

import { data, T } from "../App.vue";

export default Vue.extend({
  name: "TitleScreen",
  components: {
    SeaBackground,
    BGItem,
  },
  props: {
    State: Number,
  },
  computed: {
    States: {
      get() {
        return data.States;
      },
    },
  },
  methods: {
    T(key: string): string {
      return T(key);
    },
  },
});
